export default __webpack_public_path__ + "img/b56166d4640b2be70dc472933e8e66a8.png";